import React, { useEffect, useState } from 'react';
import AppInput from '../../../components/atoms/AppInput/AppInput';

export interface RangeCriteriaFormState {
  from: string;
  to: string;
}

interface RuleItemProps {
  value?: RangeCriteriaFormState;
  onChange: (e: RangeCriteriaFormState) => void;
  label?: string;
  placeholder?: string[];
  inputPlaceholders?: string[];
  hasError?: string;
  step?: string;
  addonRight?: React.ReactNode;
}

export const RangeCriteriaForm = ({
                                    onChange,
                                    placeholder,
                                    inputPlaceholders,
                                    value,
                                    hasError,
                                    addonRight,
                                    step,
                                  }: RuleItemProps) => {

  const [formState, setFormState] = useState(
    value || {
      from: '',
      to: '',
    },
  );

  useEffect(() => {
    onChange(formState);
  }, [formState]);

  return (
    <div className="w-full">
      <div className="flex w-full gap-3">
        <AppInput
          className={'w-full'}
          value={formState.from}
          number
          step={step}
          placeholder={inputPlaceholders && inputPlaceholders[0]}
          label={placeholder && placeholder[0]}
          addonRight={addonRight}
          onChange={(e) =>
            setFormState({
              ...formState,
              from: e.target.value,
            })
          }
        />
        <AppInput
          className={'w-full'}
          number
          value={formState.to}
          step={step}
          placeholder={inputPlaceholders && inputPlaceholders[1]}
          label={placeholder && placeholder[1]}
          addonRight={addonRight}
          onChange={(e) =>
            setFormState({
              ...formState,
              to: e.target.value,
            })
          }
        />
      </div>
      {hasError && (
        <div className="text-red-500 text-sm mb-5 absolute">{hasError}</div>
      )}
    </div>
  );
};

RangeCriteriaForm.displayName = 'RangeCriteriaForm';
